import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';
import { Card } from '../../components/Card/Card';
import ReviewCard from '../Reviews/ReviewCard';
import { SecondaryButton } from '../../components';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, switchToReviewTab } = props;

  const limitedReviews = reviews?.length > 2 ? reviews?.slice(0, 2) : reviews;
  const isMoreThatTwo = reviews?.length >= 2;

  return (
    <Card>
      <div className={css.sectionReviews}>
        <div className={css.reviewsHeader}>
          <Icon />
          <FormattedMessage id="Cappa.reviewsTitle" defaultMessage={'Reviews'} />
        </div>
        <div>
          {reviews?.length === 0 || fetchReviewsError ? (
            <div className={css.noReviewContainer}>
              <FormattedMessage
                id="ListingPage.reviewsNoReviews"
                defaultMessage={'No reviews yet'}
              />
            </div>
          ) : (
            <div className={css.reviewsWrapper}>
              {limitedReviews?.map((review, index) => {
                return (
                  <ReviewCard
                    key={index}
                    user={review?.author}
                    stars={review?.attributes?.rating}
                    content={review?.attributes?.content}
                  />
                );
              })}
              {isMoreThatTwo && (
                <div className={css.reviewGradientWrapper}>
                  <SecondaryButton
                    className={css.seeReviewsButtonWrapper}
                    onClick={switchToReviewTab}
                  >
                    <FormattedMessage
                      id="ListingPage.reviewsSeeAll"
                      defaultMessage={'See all reviews'}
                    />
                  </SecondaryButton>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

const Icon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6901 2.12756L19.8401 3.76756L21.7801 4.32756C21.9901 4.38756 22.0701 4.63756 21.9301 4.80756L20.7001 6.36756L20.7601 8.34756C20.7601 8.55756 20.5601 8.70756 20.3601 8.63756L18.4401 7.96756L16.5201 8.63756C16.3201 8.70756 16.1101 8.55756 16.1201 8.34756L16.1801 6.36756L14.9501 4.80756C14.8201 4.63756 14.9001 4.38756 15.1001 4.32756L17.0401 3.76756L18.1901 2.12756C18.3101 1.95756 18.5701 1.95756 18.6901 2.12756Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.22 18.6576H4.15C2.97 18.6576 2 17.7076 2 16.5576V7.41757C2 6.25757 2.97 5.31757 4.15 5.31757H12.77"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0199 11.2076V16.5576C19.0199 17.7176 18.0499 18.6576 16.8699 18.6576H12.3999"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.21997 18.6575V21.9975L12.4 18.6575"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.97998 10.4075H14.38"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.97998 13.5676H10.95"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SectionReviews;
